import {isNullOrUndefined} from "../../../services/Validator";

export default function DetailedCourseLevelATaskText({task}) {
    // Used in DetailedCourseScreenHeader to display
    // levelA task text

    // BUILD
    if (isNullOrUndefined(task))
        return null
    return (
        <div>
            <span className={"font-medium text-[16px] text-greyLight11"}>
                {task}
            </span>
        </div>
    );
}